import { get } from "lodash"
import { FUNCTION_CREATE_TEMPLATE, getModel } from "./chatGenerationServices"
import { createResponse } from "./cloudFunctions"
import createTemplateSchema from "./schemas/create_template.json"

const createTemplate = async ({ name, purpose, roles }) => {
  const gptModel = getModel({ roles, funcName: FUNCTION_CREATE_TEMPLATE })

  // Step 1: generate a multi-level TOC (no schema needed)

  const tocPrompt = [
    `Create a ${name} multi level table of contents for ${purpose}.`,
    `You are a helpful AI assistant that is an expert in creating templates for this purpose.`,
    `Think about the templates people normally use and the key sections normally included.`,
    `Think about the purpose of each section.`,
    `Think about the best ordering of sections.`,
    `Think how an expert would achieve the overall purpose and what TOC they'd need.`,
    `What are the key points normally included in each section?`,
    `Do NOT include boilerplate sections like title, subtitle, authors, date, target audience.`,
    `Just provide the TOC only; no extra content.`,
  ].join("\n")

  const model = getModel({ roles, funcName: FUNCTION_CREATE_TEMPLATE })

  console.log("Creating TOC with model", { model, gptModel })

  const tocResp = await createResponse({
    prompt: tocPrompt,
    model: model,
    reasoning: { effort: "low" },
    store: true,
  })

  console.log("TOC response", { tocResp })

  const tocText = tocResp?.response?.output_text ?? ""
  if (!tocText) return null

  console.log("TOC response text", { tocText })

  const responseId = tocResp?.response?.id

  // Step 2: create the actual template as strict JSON per createTemplateSchema
  const buildPrompt = [
    `Use the following TOC to create a multilevel template for "${name}" aligned to the purpose: ${purpose}.`,
    `TOC:`,
    tocText,
    ``,
    `GUIDANCE:`,
    `- Do not add numbering to headings (numbering will be added later).`,
    `- For each heading, include an associated "rationale".`,
    `- Include all researched/derived information that is relevant to the purpose.`,
    ``,
    `SYSTEM RULES:`,
    `- Return ONLY a single JSON object that validates against the provided JSON Schema.`,
    `- Do not include any fields not defined in the schema.`,
  ].join("\n")

  const templateResp = await createResponse({
    prompt: buildPrompt,
    model: "gpt-5-mini",
    previous_response_id: responseId,
    jsonSchema: createTemplateSchema,
    reasoning: { effort: "medium" },
    store: false,
  })

  console.log("%ctemplate response", "color:lightgreen", { templateResp })

  const raw = templateResp?.response?.output_text

  console.log("%craw", "color:lightgreen", { raw })

  const obj = JSON.parse(raw)

  console.log("%cparsed", "color:lightgreen", { obj })

  return obj
}

export { createTemplate }
